import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import moment from 'moment-timezone';

import { formatTime, formatTimePair } from '../../../helpers';
import { InstanceTime } from '../OfferSlots/Common';

const name = {
  swing_by: (offer: Offer) =>
    'Swing by ' + formatTimePair(offer.starts_at, offer.ends_at, offer.timezone),
  anytime: (offer: Offer) => formatTimePair(offer.starts_at, offer.ends_at, offer.timezone),
  must_post: (offer: Offer) => formatTime(offer.starts_at, true, offer.timezone),
  timed: (offer: Offer) => formatTime(offer.starts_at, true, offer.timezone),
  reservation_required: (offer: Offer) => formatTime(offer.reserve_by, true, offer.timezone),
  job: (offer: Offer) => {

    if (offer.deal_call_sheet_ready === false) {

      const start = moment(offer.display_start_date);
      const end   = offer.display_end_date !== null
        ? moment(offer.display_end_date)
        : null;

      return end
        ? start.format('MMM. DD') + ' - ' + end.format('MMM. DD')
        : start.format('MMM. DD')
    }

    let earliest;

    offer.attendees.forEach((attendee) => {

      if (attendee.call_sheet_status === 'ready'
        && attendee.call_time !== undefined
        && (earliest === undefined || earliest.isAfter(moment(attendee.call_time)))) {

        earliest = moment(attendee.call_time);
      }
    });

    return (earliest !== null && earliest !== undefined)
      ? moment(earliest).format('MMM. DD') + ', ' + formatTime(earliest)
      : '';
  },
  gift: (offer: Offer, c: OfferName) =>
    offer.mode === 'claim' ||
    (offer.mode === 'apply' && offer.deliberation_status === 'finalized') ? (
      <a
        href="#"
        style={{ textDecoration: 'underline', color: '#7ea2aa' }}
        onClick={() => {
          c.props.push('/offers/' + offer.id + '/shipment');
        }}
      >
        Ship + Track
      </a>
    ) : (
      ''
    ),
};

const colors = {
  swing_by: '#909798',
  anytime: '#415859',
  must_post: '#7a637b',
  timed: '#b4a361',
  reservation_required: '#994f4f',
  gift: '#7ea2aa',
  job: '#77ab59',
};

declare interface Props {
  offer: Offer;
  main?: boolean;
  push: Function;
}

class OfferName extends React.Component<Props> {
  render() {

    if (!name[this.props.offer.type]) return null;

    return (
      <InstanceTime color={colors[this.props.offer.type]} padding={this.props.main}>
        {this.props.main &&
          this.props.offer.type === 'timed' &&
          !this.props.offer.is_group &&
          'Timed '}
        {name[this.props.offer.type](this.props.offer, this)}
      </InstanceTime>
    );
  }
}

export default connect(null, { push })(OfferName);
